import { NgModule } from '@angular/core';
import { SharedModule } from './shared.module';
import { StandaloneModule } from './standalone.module';
import { UserManagementModule } from './userManagement.module';
import { TenantManagementComponent } from '../components/ehr/tenant-management/tenant-management.component';
import { CareTeamManagementComponent } from '../components/ehr/tenant-management/care-team-management/care-team-management.component';
import { CareTeamTemplateFormComponent } from '../components/ehr/tenant-management/care-team-management/care-team-template-form/care-team-template-form.component';

@NgModule({
  declarations: [
    TenantManagementComponent,
    CareTeamManagementComponent,
    CareTeamTemplateFormComponent,
  ],
  imports: [SharedModule, StandaloneModule, UserManagementModule],
  exports: [TenantManagementComponent, CareTeamManagementComponent],
})
export class TenantManagementModule {}
